export default function ProfileStep2({ form, updateField }) {
  return (
    <div className="space-y-3">
      <div className="bg-amber-50 border border-amber-100 rounded-xl p-4 mb-3">
        <p className="text-sm text-amber-800 font-medium">Recomendamos alterar sua senha padrao</p>
        <p className="text-xs text-amber-600 mt-1">Defina uma senha segura para proteger sua conta. Se preferir manter a atual, clique em "Concluir".</p>
      </div>
      <div>
        <label className="block text-xs font-medium text-gray-600 mb-1">Nova Senha</label>
        <input type="password" value={form.new_password} onChange={function(e) { updateField("new_password", e.target.value); }}
          className="w-full px-3 py-2.5 border border-gray-200 rounded-xl text-sm focus:outline-none focus:ring-2 focus:ring-[#3B82F6]/30 focus:border-[#3B82F6]"
          placeholder="Minimo 6 caracteres" data-testid="profile-new-password" />
      </div>
      <div>
        <label className="block text-xs font-medium text-gray-600 mb-1">Confirmar Nova Senha</label>
        <input type="password" value={form.confirm_password} onChange={function(e) { updateField("confirm_password", e.target.value); }}
          className="w-full px-3 py-2.5 border border-gray-200 rounded-xl text-sm focus:outline-none focus:ring-2 focus:ring-[#3B82F6]/30 focus:border-[#3B82F6]"
          placeholder="Repita a nova senha" data-testid="profile-confirm-password" />
      </div>
    </div>
  );
}
